import React, { useEffect } from "react";
import LandingHeader from "../../Components/Landing/LandingHeader";
import Hero from "../../Components/Landing/Hero";
import ProductsSection from "../../Components/Landing/ProductsSection";
import HowItWorks from "../../Components/Landing/HowItWorks";
import WhyChoose from "../../Components/Landing/WhyChoose";
import Occasions from "../../Components/Landing/Occasions";
import CTASection from "../../Components/Landing/CTASection";
import LandingFooter from "../../Components/Landing/LandingFooter";
import "./landing.css";

export default function LandingPage() {
  useEffect(() => {
    document.documentElement.classList.add("landing-page");
    return () => document.documentElement.classList.remove("landing-page");
  }, []);

  return (
    <div className="landing-root font-jakarta text-ink bg-white antialiased">
      <LandingHeader />
      <div id="top">
        <Hero />
        <ProductsSection />
        <HowItWorks />
        <WhyChoose />
        <Occasions />
        <CTASection />
      </div>
      <LandingFooter />
    </div>
  );
}
